import { FaBriefcase, FaFileAlt, FaUserFriends, FaUsers, FaProjectDiagram, FaChartLine } from "react-icons/fa";

export const NavBarList = [
  {
    text: "Заказчики",
    href: "/customers",
    icon: FaUsers,
  },
  {
    text: "Проекты",
    href: "/projects",
    icon: FaProjectDiagram,
  },
  {
    text: "Заявки",
    href: "/applications",
    icon: FaFileAlt,
  },
  {
    text: "Вакансии",
    href: "/vacancy",
    icon: FaBriefcase,
  },
  {
    text: "Кандидаты",
    href: "/candidate",
    icon: FaUserFriends,
  },
  {
    text: "Аналитика",
    href: "/analytics",
    icon: FaChartLine,
  },
];
